// Per-scene text-layout overrides — text DIRECTION (rtl/ltr), paragraph
// ALIGNMENT (right/left/center), and a dragged block POSITION — that the admin
// sets from the scene editor. Resolving them is shared by the customer
// BookViewer, the admin scene-editor preview, and — mirrored line-for-line — the
// server bookPdf, so the on-screen book and the printed PDF stay identical.
// Keep in sync with server/services/bookPdf.js (sceneTextLayout / sceneBlockHtml).

const DIRS = ['rtl', 'ltr'];
const ALIGNS = ['left', 'right', 'center'];

// Resolve a scene's overrides against the story's base direction. Returns the
// effective { dir, align, positioned, x, y }: `align` null keeps the renderer's
// default alignment; `positioned` false keeps the default flex-centered block.
// The (x, y) are leaf-relative percentages of the text page — the SAME frame the
// server bookPdf uses — marking the CENTRE of the text block.
export function sceneTextLayout(scene, storyDir) {
  const dir = DIRS.includes(scene?.textDir) ? scene.textDir : (storyDir === 'ltr' ? 'ltr' : 'rtl');
  const align = ALIGNS.includes(scene?.textAlign) ? scene.textAlign : null;
  const p = scene?.textPosition;
  const positioned = !!p && Number.isFinite(p.x) && Number.isFinite(p.y);
  return { dir, align, positioned, x: positioned ? p.x : null, y: positioned ? p.y : null };
}

// Normalize a saved (possibly Mongoose-subdoc) textPosition into a plain { x, y }
// or null (unset → the default centered block).
export function normScenePos(p) {
  return p && Number.isFinite(p.x) && Number.isFinite(p.y) ? { x: p.x, y: p.y } : null;
}
